








import Vue from 'vue'
import { setSearchQuery } from '../store/actions';
import { routerReplace } from '../helpers';
import { ITranslations } from '../store/state';
import { EventBus } from '../helpers/EventBus.vue';

interface SearchInputData {
    query: string
}

interface SearchInputMethods {
	setSearchQuery(): void
}

interface SearchInputComputed {
	translations: ITranslations
}

export default Vue.extend<SearchInputData, SearchInputMethods, {} , {}>({
	name: 'SearchInput',
    computed: {
       translations() {
			return this.$store.getters.translations
		} 
    },
	props: {
		article: {}
	},
    data() {
        return {
            query: ''
        }
    },
    methods: {
        setSearchQuery() {
            this.$store.dispatch(setSearchQuery({query: this.query}))
            routerReplace({
				query: this.$store.getters.getParams
			})
            EventBus.$emit('scrollToTop');
        }
    }
})
